'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Showcase = undefined;

var _templateObject = _taggedTemplateLiteral(['\n    display: block;\n    margin: 0 auto;\n    margin-top: 1em;\n'], ['\n    display: block;\n    margin: 0 auto;\n    margin-top: 1em;\n']);

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Buttons = require('./Buttons');

var _Grid = require('./Grid');

var _Toggle = require('./Toggle');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
/*:: import type {ComponentType} from 'react' */


var ShowcaseButton = (0, _styledComponents2.default)(_Buttons.Button)(_templateObject);
/*::
type Props = {|
    sizes?: {
      mobile: number,
      tablet: number,
      laptop: number,
      desktop: number
    },
    less: string,
    more: string,
    children: React.Node,
    size: number,
|}
*/
var Showcase /*: ComponentType<Props> */ = exports.Showcase = function Showcase(props) {
  return React.createElement(
    _Toggle.Toggle,
    null,
    function (isOn, toggle) {
      return React.createElement(
        'div',
        null,
        React.createElement(
          _Grid.Grid,
          { sizes: props.sizes },
          isOn ? props.children : React.Children.toArray(props.children).slice(0, props.size)
        ),
        React.createElement(
          ShowcaseButton,
          { primary: true, onClick: toggle },
          isOn ? props.less : props.more
        )
      );
    }
  );
};

Showcase.displayName = 'Showcase';


//////////////////
// WEBPACK FOOTER
// ../tutellus-ui/lib/Showcase.js
// module id = 656
// module chunks = 0